import { literal, struct, union } from 'io-ts/Decoder';

import { Id as TransactionId } from '../../../../../transaction/Id';

/** Body for the backend-driven MTO invoice CSV export endpoint. */
export const ExportRequest = struct({
	transactionId: TransactionId,
	mode: union(literal('current'), literal('history')),
});
